export default __webpack_public_path__ + "static/oBlock-dc9815b336576e6064f9a3702550b2b6.svg";